export const POS_SETTINGS_KEY = 'posSettings';

export const PERSISTED_LOCAL_STORAGE_KEYS = ['deviceId', POS_SETTINGS_KEY];

export const clearLocalStorageExceptPersisted = () => {
  const preserved = PERSISTED_LOCAL_STORAGE_KEYS.map((key) => [
    key,
    localStorage.getItem(key),
  ]);
  localStorage.clear();
  preserved.forEach(([key, value]) => {
    if (value !== null && value !== undefined) {
      localStorage.setItem(key, value);
    }
  });
};
